import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/i18n/config';
import { queryClient } from '@/shared/lib/queryClient';
import { AuthProvider } from '@/modules/auth/context/AuthContext';
import { TenantProvider } from '@/providers/TenantProvider';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TenantProvider>{children}</TenantProvider>
        </AuthProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
